import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  function matchFaqHeights() {
    const columns = document.querySelectorAll('.faq__column');
    if (columns.length < 2) return;

    const leftQuestions = columns[0].querySelectorAll('.faq__item-question');
    const rightQuestions = columns[1].querySelectorAll('.faq__item-question');

    leftQuestions.forEach((el) => (el.style.height = 'auto'));
    rightQuestions.forEach((el) => (el.style.height = 'auto'));

    if (window.innerWidth > 1023) {
      leftQuestions.forEach((leftEl, i) => {
        const rightEl = rightQuestions[i];
        if (rightEl) {
          const maxHeight = Math.max(leftEl.offsetHeight, rightEl.offsetHeight);
          leftEl.style.height = maxHeight + 'px';
          rightEl.style.height = maxHeight + 'px';
        }
      });
    }
  }

  window.addEventListener('load', matchFaqHeights);
  window.addEventListener('resize', matchFaqHeights);

  const items = document.querySelectorAll('.faq__item');

  if (!items.length) return;

  items.forEach((item) => {
    const title = item.querySelector('.faq__item-question');
    const description = item.querySelector('.faq__item-answer');

    if (!title || !description) return;

    description.style.height = '0px';

    title.addEventListener('click', () => {
      const isActive = item.classList.contains('is-active');

      items.forEach((el) => {
        el.classList.remove('is-active');
        const a = el.querySelector('.faq__item-answer');
        if (a) a.style.height = '0px';
      });

      if (!isActive) {
        item.classList.add('is-active');
        description.style.height = description.scrollHeight + 'px';
      }
    });
  });
});
